import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import {
	RecentTimelineItemTypeFilterEnum,
	TimelineHorizonEnum,
	UpcomingTimelineItemTypeFilterEnum,
} from "web_myplann/Infrastructure/Api/Api";

export type TimelineFilterState = {
	horizon: TimelineHorizonEnum;
	recentType: RecentTimelineItemTypeFilterEnum;
	upcomingType: UpcomingTimelineItemTypeFilterEnum;
};

export const DEFAULT_TIMELINE_FILTER: TimelineFilterState = {
	horizon: TimelineHorizonEnum.HalfYear,
	recentType: RecentTimelineItemTypeFilterEnum.All,
	upcomingType: UpcomingTimelineItemTypeFilterEnum.All,
};

const STORAGE_KEY = "myplann-notification-center-filter-v2";

export const timelineFilterAtom = atomWithStorage<TimelineFilterState>(
	STORAGE_KEY,
	DEFAULT_TIMELINE_FILTER,
);

export const isTimelineFilterDefaultAtom = atom<boolean>((get) => {
	const value = get(timelineFilterAtom);
	return (
		value.horizon === DEFAULT_TIMELINE_FILTER.horizon &&
		value.recentType === DEFAULT_TIMELINE_FILTER.recentType &&
		value.upcomingType === DEFAULT_TIMELINE_FILTER.upcomingType
	);
});
